import React from 'react';
import { Menu } from './style';
import { useRouter } from 'next/router';

// Components
import Link from 'components/common/Link';

// Libs
import ModalManager from 'libs/ModalManager';

const Header = ({ buttons, items, isAuth, webConfig }) => {
	const router = useRouter();
    let reverseButtons = [...buttons]
    reverseButtons.reverse()

	return (
	    <Menu webConfig={webConfig}>
            <div
                className='column-flex'
            >
                {reverseButtons.map(b => (
                    <div 
                        key={b.id}
                        className={`button ${b.class} width-100`}
                        onClick={b.onClick}
                    >
                      {isAuth ? b.alternateLabel ?? b.label : b.label}
                    </div>
                ))}
            </div>
            <div
                className='column-flex menu'
            >
                {items.map(i => (
                    <>
                    {!i.desktopOnly &&
                    <Link 
                        key={i.id}
                        className={router.pathname === i.link ? 'item active-item' : 'item'}
                        to={i.link}
                        params={i.params}
                        onClick={() => ModalManager.hide()}
                    >
                        {i.icon}
                        {i.label}
                    </Link>
                    }
                    </>
                ))}
            </div>   
	    </Menu>
	);
};

export default Header;
